import type { StaticImageData } from 'next/image'
import headshotLeft from '@/assets/images/search-providers-promo/headshot-left.png'
import headshotCenter from '@/assets/images/search-providers-promo/headshot-center.png'
import headshotRight from '@/assets/images/search-providers-promo/headshot-right.png'

/**
 * Promo avatar stack, left to right.
 * Kept separate from badge/promo-photo assets so FeaturedCategory's ProvidersLeading
 * does not pull the large search-tile promo photos into the home bundle.
 */
export const searchProvidersPromoHeadshots: readonly [StaticImageData, StaticImageData, StaticImageData] = [
    headshotLeft,
    headshotCenter,
    headshotRight,
]
